<template>
  <v-container class="pa-4">
    <v-card>
      <v-card-title>Dev Debug Status</v-card-title>
      <v-card-text>
        <div>
          <strong>Feature Flags (settings.feature_flags)</strong>
          <pre>{{ featureFlags }}</pre>
        </div>

        <div>
          <strong>Inactivity Settings (settings.inactivitySettings)</strong>
          <pre>{{ inactivitySettings }}</pre>
        </div>

        <div>
          <strong>Router Paths</strong>
          <pre>{{ routerPaths }}</pre>
        </div>

        <div>
          <strong>Env (process.env.VUE_APP_FEATURE_FILE_FAST)</strong>
          <pre>{{ envVar }}</pre>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "DevDebug",
  computed: {
    featureFlags() {
      return this.$store.state.settings?.feature_flags || this.$store.getters['settings/isFileFastEnabled'] ? this.$store.state.settings.feature_flags : this.$store.state.settings?.feature_flags || {};
    },
    inactivitySettings() {
      return this.$store.getters['settings/inactivitySettings'] || {};
    },
    routerPaths() {
      try {
        return this.$router.getRoutes().map(r => r.path).join('\n');
      } catch (e) {
        return String(e);
      }
    },
    envVar() {
      return process.env.VUE_APP_FEATURE_FILE_FAST;
    }
  }
};
</script>

<style scoped>
pre{white-space:pre-wrap;background:#f4f6f8;padding:12px;border-radius:6px}
</style>
